import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

// Constant Feature items
const FeatureItems = [
    {
        title: "Remote Learning",
        info: "With us, you can explore and learn anytime, anywhere. There are no limits to when or where you can learn. We personalize your learning experience to match your needs. Join us and start your learning journey today!",
        image: "feature-image-01.png",
        bgColor: "card-bg-1",
        link: "#"
    },
    {
        title: "Awesome Tutors",
        info: "Were here to make learning tech subjects not just accessible, but exciting and fulfilling too. With our platform, you'll discover a world of innovative teaching methods and engaging content designed to help you master the latest technologies.",
        image: "feature-image-02.png",
        bgColor: "card-bg-2",
        link: "#"
    },
    {
        title: "Career Guideline",
        info: "We understand the challenges and complexities of choosing a career path in the tech industry. That's why we've created a comprehensive platform to provide you with guidance, resources, and insights to help you succeed.",
        image: "feature-image-04.png",
        bgColor: "card-bg-4",
        link: "#"
    }
];

const AboutUsFeature = ({ wrapperClass, alignment, style }) => {

    return (
        <div className={`row y-gap-30 pt--50 ${wrapperClass || ""}`}>
            {(FeatureItems || []).map((data, i) => (
                <ScrollAnimation
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    className={`col-lg-4 col-md-6 col-12 ${alignment ? alignment : ""} ${style ? style : ""}`}
                    animateOnce={true}
                    key={i}
                >
                    <div className={`service-card service-card-2 ${data?.bgColor}`}>
                        <div className="inner">
                            <div className="icon">
                                <div className="icon-img">
                                    <img src={`${process.env.PUBLIC_URL}/images/feature/feature-01/${data?.image}`} alt="Feature Thumb" />
                                </div>
                                <div className="shape-list">
                                    <img className="shape shape-1" src="/images/feature/feature-01/feature-icon-01.png" alt="Shape Particle" />
                                    <img className="shape shape-2" src="/images/feature/feature-01/feature-icon-02.png" alt="Shape Particle" />
                                    <img className="shape shape-3" src="/images/feature/feature-01/feature-icon-03.png" alt="Shape Particle" />
                                </div>
                            </div>
                            <div className="content">
                                <h6 className="title">{data?.title}</h6>
                                <p className="description">{data?.info}</p>
                            </div>
                        </div>
                    </div>
                </ScrollAnimation>
            ))}
        </div>
    )
}

export default AboutUsFeature;